import { createSelector } from 'reselect'

const getItems = (state) => state.playQueue.items
const getSelectedItem = (state) => state.playQueue.selectedItem
const getSelectedSong = (state) => state.playQueue.selectedSong
const getIsPlaying = (state) => state.player.isPlaying
const getIsIpadView = (state) => state.global.isIpadView
const getPlayQueue = (state) => state.playQueue

export const playQueueSelector = createSelector(
  [
    getItems,
    getSelectedItem,
    getSelectedSong,
    getIsPlaying,
    getIsIpadView,
    getPlayQueue
  ],
  (items, selectedItem, selectedSong, isPlaying, isIpadView, playQueue) => ({
    items,
    selectedItem,
    selectedSong,
    isPlaying,
    isIpadView,
    playQueue
  })
)
